/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// material
import { Card, Container } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import TableSearch from 'src/components/table/TableSearch';
import { USER_LIST_HEAD } from 'src/constants/Dashboard';
import { useSnackbar } from 'notistack5';
import {
  filterUsers,
  deleteUsers,
  statusChange,
  resetUsersMsg,
  resetCreateUsersStatus
} from 'src/redux/slices/users__';
import { useDispatch, useSelector } from 'src/redux/store';
import AlertDialog from 'src/components/common-components/AlertDialog';

// ----------------------------------------------------------------------
UsersList.propTypes = {
  setEditId: PropTypes.func,
  setDeleteId: PropTypes.func,
  setUserListStatus: PropTypes.func,
  deleteId: PropTypes.string,
  usersList: PropTypes.array,
  userListStatus: PropTypes.bool,
  loading: PropTypes.bool
};
// ----------------------------------------------------------------------

export default function UsersList({
  setEditId,
  setDeleteId,
  setUserListStatus,
  deleteId,
  usersList,
  userListStatus,
  loading
}) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const dispatch = useDispatch();
  const { createUsersStatus, usersMsg } = useSelector((state) => state.users__);

  useEffect(() => {
    if (createUsersStatus) {
      enqueueSnackbar('User Disabled Successfully', { variant: 'success' });
      dispatch(resetCreateUsersStatus());
    }
    if (usersMsg) {
      setClose(true);
      setOpen(true);
      dispatch(resetUsersMsg());
      setTitle('Disable User');
      setContent(usersMsg);
    }
  }, [usersMsg, createUsersStatus]);

  const handleUserListSwitch = (e) => {
    setUserListStatus(!e.target.checked);
  };
  const handleDelete = (id) => {
    setClose(false);
    setTitle('Delete User?');
    setContent('Are you sure want to delete user data permanently??');
    setOpen(true);
    setDeleteId(id);
  };

  const handleDeleteDispatch = () => {
    dispatch(deleteUsers(deleteId));
    enqueueSnackbar('User Deleted Successfully', {
      variant: 'success'
    });
    setOpen(false);
  };

  const handleDisable = async (id) => {
    dispatch(statusChange(id, false));
  };

  const handleRestore = async (id) => {
    dispatch(statusChange(id, true));
    enqueueSnackbar('user Restore Successfully', {
      variant: 'success'
    });
  };

  const handleEdit = (id) => {
    setEditId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container maxWidth={themeStretch ? false : 'lg'} style={{ padding: 0 }}>
      <Card>
        <AlertDialog
          title={title}
          content={content}
          okFunction={close ? handleClose : handleDeleteDispatch}
          open={open}
          setOpen={setOpen}
        />
        <TableSearch
          tableHead={USER_LIST_HEAD}
          tableData={usersList && usersList}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleDisable={handleDisable}
          handleRestore={handleRestore}
          status={userListStatus}
          switchButton
          filterComponent={filterUsers}
          switchButtonResponse={handleUserListSwitch}
          loading={loading}
        />
      </Card>
    </Container>
  );
}
